import { createSlice } from '@reduxjs/toolkit'

/**
 * State for the new dynamic EPR Packaging flow (NLD, FIN, SWE, EST).
 * selectedByLevel[0] = selected names for step 1 (subcategory_1)
 * selectedByLevel[1] = array of [cat1, cat2] for step 2
 * selectedByLevel[2] = array of [cat1, cat2, cat3] for step 3
 * etc.
 */
const initialState = {
  selectedByLevel: [],
}

const eprNewArchitectureSlice = createSlice({
  name: 'eprNewArchitecture',
  initialState,
  reducers: {
    setSelectedByLevel(state, action) {
      state.selectedByLevel = action.payload
    },
    selectCategoryNew(state, action) {
      const { levelIndex, path, value, checked } = action.payload
      // levelIndex 0 = step 1, 1 = step 2, ...
      // path = array of selected values from previous steps (for step 1 path is [])
      // value = selected item (string name or object with name)
      const name = typeof value === 'object' && value?.name != null ? value.name : String(value)

      while (state.selectedByLevel.length <= levelIndex) {
        state.selectedByLevel.push([])
      }

      const level = state.selectedByLevel[levelIndex]
      const fullPath = [...path, name]

      if (checked) {
        const exists = level.some(
          (row) =>
            Array.isArray(row) &&
            row.length === fullPath.length &&
            row.every((v, i) => v === fullPath[i])
        )
        if (!exists) {
          state.selectedByLevel[levelIndex] = [...level, fullPath]
        }
      } else {
        state.selectedByLevel[levelIndex] = level.filter(
          (row) =>
            !Array.isArray(row) ||
            row.length !== fullPath.length ||
            row.some((v, i) => v !== fullPath[i])
        )
      }
    },
    resetNewArchitecture() {
      return initialState
    },
  },
})


export const { setSelectedByLevel, selectCategoryNew, resetNewArchitecture } =
  eprNewArchitectureSlice.actions
export default eprNewArchitectureSlice.reducer
